import { Search } from "lucide-react";

export default function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="pageInset">
      <div className="card w-full h-[60px] flex items-center justify-between px-4">
        <div className="flex items-center gap-2 flex-shrink w-full pr-6">
          <Search className="w-6 h-6 text-slate-400" />
          <input
            type="text"
            className="w-full border-none focus-within:ring-0 rounded-lg h-[60px] leading-[60px] bg-transparent w-full"
            placeholder="Rechercher par mot clé, secteurs d'activité..."
          />
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">{children}</div>
      </div>
    </div>
  );
}
